import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { useContext, useMemo } from 'react';
import { SmartSendContext } from '../../../lib/context/SmartSendContext';
import { ToggleSelectionItemsAction } from '../../../lib/context/SmartSendContextModels';
import { useAnalytics } from '@parcel2go/npm-p2g-app';
import { EventSections } from '~/apps/smartsend/lib/events/EventLogger';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';

interface props {
  selected: number;
  total: number;
  filterKey: string;
}

const sections = [EventSections.SmartSend, EventSections.QuickSelect];

const QuickToggleAll = (props: props) => {
  const ctx = useContext(SmartSendContext);
  const { track } = useAnalytics();
  const isSelected = useMemo(() => props.total > 0 && props.selected === props.total, [props.selected, props.total]);

  const toggleAll = (v: boolean) => {
    track({
      type: 'smartsend_quick_select_click',
      payload: {
        ...GenerateBaseAnalyticsPayload(sections),
        action: v ? 'select-all' : 'clear',
        value: v
      }
    });
    ctx.dispatch(new ToggleSelectionItemsAction(props.filterKey, 'TOGGLE_ALL', v));
  };

  return (
    <P2GCheckBoxLegacy
      id="QuickSelect"
      onChange={() => toggleAll(!isSelected)}
      checked={isSelected}
      labelPlacement="end"
      variant="primary"
      error={false}
      label={null}
    />
  );
};

export default QuickToggleAll;
